import React from 'react'
import PropTypes from 'prop-types'
import FieldGroup from '../../common/forms/FieldGroup'
import SubmitButton from '../../common/forms/SubmitButton'
import SubmitSpinner from '../../common/Spinners/SubmitSpinner'
import SuccessCheckMessage from '../../common/SuccessCheckMessage'
import { Form } from 'react-bootstrap'
import * as styles from './_AdministrationResetPassword.scss'
import withStyles from 'isomorphic-style-loader/withStyles'

const AdministrationResetPassword = ({
  validationstate,
  emailAddress,
  submitting,
  submitted,
  reset,
  emailAddressChange
}) => (
  <div className={styles.wrapper}>
    <h2 className={styles.heading}>Password Reset</h2>

    <form
      noValidate
      onSubmit={(event) => {
        event.preventDefault()
        reset()
      }}
    >
      <FieldGroup
        required
        type="email"
        disabled={submitting || submitted}
        value={emailAddress}
        handleChange={emailAddressChange}
        placeholder="Email address"
        label="Email address"
        message={validationstate.emailAddress.message}
        isInvalid={validationstate.emailAddress.isInvalid}
      />

      <Form.Group>
        <SubmitButton
          buttonText="Reset password"
          isValid={validationstate.formIsValid && !submitted}
          isSubmitting={submitting}
        />
        {submitting && <SubmitSpinner />}
        {submitted && (
          <SuccessCheckMessage message="Password reset email sent." />
        )}
      </Form.Group>
    </form>
  </div>
)

AdministrationResetPassword.propTypes = {
  validationstate: PropTypes.object.isRequired,
  emailAddress: PropTypes.string.isRequired,
  submitting: PropTypes.bool.isRequired,
  submitted: PropTypes.bool.isRequired,
  reset: PropTypes.func.isRequired,
  emailAddressChange: PropTypes.func.isRequired
}

export default withStyles(styles)(AdministrationResetPassword)
